export default __webpack_public_path__ + "static/media/captionsBlack.36eef12d.svg";